import { Component, Input } from '@angular/core';

import { Address } from '../models/address.model';


@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent {
  @Input() address: Address;
  @Input() displayCountry = false;

  /**
   * Returns formatted zip+4
   */
  get FormattedPostalCode(): string {
    if (this.address.postalCode.length === 9) {
      return this.address.postalCode.substr(0, 5) + '-' + this.address.postalCode.substr(5, 4);
    } else {
      return this.address.postalCode;
    }
  }

}
